/* =============================================================== */
/*  IT IS GOOD HEADER — JS MODULE                                  */
/*  --------------------------------------------------------------- */
/*  Purpose: Unifies all header interactions including sticky      */
/*  behavior, mobile drawer toggling, accessibility hooks, and     */
/*  live cart count updates.                                       */
/* =============================================================== */

window.itisgoodHeader = (function () {
  const selectors = {
    header: '.itisgood-header',
    drawer: '.mobile-drawer',
    toggle: '.mobile-toggle',
    skipLink: 'a.skip-to-content',
    cartBubble: '.cart-count-bubble',
  };

  function init() {
    bindStickyHeader();
    bindMobileDrawer();
    bindAccessibility();
    bindCartSync();
  }

  /* ------------------------------------------------------------- */
  /* 1. Sticky Header Motion                                       */
  /* ------------------------------------------------------------- */
  function bindStickyHeader() {
    const header = document.querySelector(selectors.header);
    if (!header) return;
    const threshold = 40;
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (scrollY > threshold) {
        if (!header.classList.contains('is-sticky')) {
          header.classList.add('is-sticky');
          requestAnimationFrame(() => header.classList.add('shrink'));
        }
      } else {
        header.classList.remove('shrink');
        header.classList.remove('is-sticky');
      }
    });
  }

  /* ------------------------------------------------------------- */
  /* 2. Mobile Drawer Toggle                                       */
  /* ------------------------------------------------------------- */
  function bindMobileDrawer() {
    const toggle = document.querySelector(selectors.toggle);
    const drawer = document.querySelector(selectors.drawer);
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', () => {
      drawer.classList.toggle('active');
      document.body.classList.toggle('drawer-open', drawer.classList.contains('active'));
    });

    document.addEventListener('click', (e) => {
      if (drawer.classList.contains('active') && !drawer.contains(e.target) && !toggle.contains(e.target)) {
        drawer.classList.remove('active');
        document.body.classList.remove('drawer-open');
      }
    });
  }

  /* ------------------------------------------------------------- */
  /* 3. Accessibility: Skip Link Focus                             */
  /* ------------------------------------------------------------- */
  function bindAccessibility() {
    const skip = document.querySelector(selectors.skipLink);
    if (!skip) return;
    skip.addEventListener('click', (e) => {
      const main = document.querySelector('main');
      if (main) {
        e.preventDefault();
        main.setAttribute('tabindex', '-1');
        main.focus();
        window.scrollTo({ top: main.offsetTop, behavior: 'smooth' });
      }
    });
  }

  /* ------------------------------------------------------------- */
  /* 4. Dynamic Cart Count Update (Resilient)                      */
  /* ------------------------------------------------------------- */
  function bindCartSync() {
    const bubble = document.querySelector(selectors.cartBubble);
    if (!bubble) return;

    const updateCartCount = () => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const count = cart.item_count || 0;
          bubble.textContent = count;
          bubble.classList.add('updated');
          setTimeout(() => bubble.classList.remove('updated'), 300);
        })
        .catch((err) => console.error('Cart count update failed:', err));
    };

    // Event-based triggers
    document.addEventListener('cart:updated', updateCartCount);
    document.addEventListener('cart:refresh', updateCartCount);

    // Shopify PubSub support
    if (window.Shopify && Shopify.theme && Shopify.theme.pubsub) {
      Shopify.theme.pubsub.subscribe('cart:updated', updateCartCount);
    } else if (window.Shopify && Shopify.PubSub && Shopify.PubSub.PUB_SUB_EVENTS) {
      Shopify.PubSub.subscribe(Shopify.PubSub.PUB_SUB_EVENTS.cartUpdate, updateCartCount);
    }

    // Fallback for forms
    document.body.addEventListener('submit', (e) => {
      if (e.target && e.target.matches('form[action*="/cart/add"]')) {
        setTimeout(updateCartCount, 600);
      }
    });

    // Section reloads (Shopify dynamic rendering)
    document.addEventListener('shopify:section:load', (evt) => {
      const el = evt && evt.target;
      if (el && el.id && el.id.includes('header')) updateCartCount();
    });

    // Initialize immediately and periodically refresh
    updateCartCount();
    setInterval(updateCartCount, 10000);
  }

  /* ------------------------------------------------------------- */
  /* 5. Re-Init on Shopify Dynamic Reloads                         */
  /* ------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', () => {
    init();
  });

  return { init };
})();

/* Initialize on page load */
document.addEventListener('DOMContentLoaded', function () {
  if (window.itisgoodHeader) itisgoodHeader.init();
});
